import React, { createContext, useState, useEffect } from "react";

// Create the ThemeContext
export const ThemeContext = createContext();

const getThemeFromStorage = () => {
  const theme = localStorage.getItem("theme");

  // ✅ If theme exists, use it
  if (theme !== null) {
    return JSON.parse(theme);
  }

  // ✅ Default = DARK MODE
  return false;
};

// ThemeProvider component
export const ThemeProvider = ({ children, sendingModule }) => {
  const [isLightMode, setIsLightMode] = useState(getThemeFromStorage);

  const handleDarkmode = () => {
    setIsLightMode((prevMode) => {
      const newMode = !prevMode;
      if (sendingModule) sendingModule(newMode);
      return newMode;
    });
  };

  useEffect(() => {
    // ✅ Apply class
    document.body.className = isLightMode ? "light-theme" : "dark-theme";

    // ✅ Save to storage
    localStorage.setItem("theme", JSON.stringify(isLightMode));
  }, [isLightMode]);

  return (
    <ThemeContext.Provider value={{ isLightMode, handleDarkmode }}>
      {children}
    </ThemeContext.Provider>
  );
};
